<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card">
            <el-page-header content="手动退款" :icon="null" title="退款管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">查询</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                    <!-- <el-button @click="auditing">退款审核</el-button> -->
                </template>
                <el-form :model="search" label-width="80px" class="demo-ruleForm">
                    <el-row :gutter="20">
                        <!-- <el-col :span="8">
                            <el-form-item label="用户ID:" prop="userId">
                                <el-input v-model="search.userId" placeholder="请输入用户ID" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                            <el-form-item label="手机号:" prop="userPhone">
                                <el-input v-model="search.userPhone" type="number" placeholder="请输入手机号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="支付订单:" prop="orderNumber">
                                <el-input v-model="search.orderNumber" placeholder="请输入支付订单号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="退款状态:" prop="refundStatus">
                                <el-select v-model="search.refundStatus" class="m-2" clearable placeholder="请选择退款状态"
                                    style="width: 100%" @change="searchFun(1)">
                                    <el-option v-for="item in state.options" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">

                        <el-col :span="8">
                            <el-form-item label="退款原因:" prop="refundReason">
                                <el-input v-model="search.refundReason" placeholder="请输入退款原因"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="退款时间:" prop="daterange">
                                <el-date-picker v-model="search.daterange" type="datetimerange" range-separator="-"
                                    start-placeholder="开始时间" end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss"
                                    value-format="YYYY-MM-DD HH:mm:ss" date-format="YYYY-MM-DD" time-format="HH:mm:ss"
                                    style="width: 100%" @change="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 347px)" row-key="id"
                v-loading="state.tableLoading" @cell-click="handleCellClick">
                <!-- <el-table-column prop="userId" label="用户ID" min-width="200px" /> -->
                <el-table-column prop="userPhone" label="手机号码" min-width="120px" />
                <el-table-column prop="refundStatus" label="订单状态" min-width="130px">
                    <template #default="scope">
                        <el-text class="mx-1" type="success" v-if="scope.row.refundStatus == '已退款'">
                            {{ scope.row.refundStatus }}
                        </el-text>
                        <el-text class="mx-1" type="error"
                            v-else-if="scope.row.refundStatus == '已拒绝' || scope.row.refundStatus == '拒绝'">
                            {{ scope.row.refundStatus }}
                        </el-text>
                        <el-text class="mx-1" type="warning" v-else>
                            {{ scope.row.refundStatus }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="applicationRefundAmount" label="退款金额" min-width="100px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.applicationRefundAmount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="vin" label="车架号" min-width="180px">
                    <template #default="scope">
                        <el-link type="primary">{{ scope.row.vin }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="refundReason" label="退款/拒绝原因" min-width="180px" />
                <el-table-column prop="orderNumber" label="支付订单" min-width="200px" />
                <el-table-column prop="refundSerialNumber" label="退款平台的交易单号" min-width="300px" />
                <el-table-column fixed="right" label="操作" width="105px">
                    <template #default="scope">
                        <el-button v-if="scope.row.refundStatus == '处理中' || scope.row.refundStatus == '待处理'"
                            type="primary" @click="auditing(scope.row)" size="small">退款审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <el-dialog v-model="state.dialogVisible1" title="退款审核" width="500">
        <el-form label-position="top">
            <el-form-item label-width="0">
                <el-input v-model="state.reason" type="textarea" :rows="4" autocomplete="off" placeholder="请输入拒绝退款原因" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="handleDialogClick(1)">拒绝</el-button>
                <el-button type="primary" @click="handleDialogClick(2)">同意</el-button>
            </div>
        </template>
    </el-dialog>
    <el-dialog v-model="state.dialogVisible" title="报告预览" width="450" destroy-on-close>
        <div class="dialog-content">
            <iframe :src="state.reportUrl" style="width: 100%;height: 100%;" frameborder="0"></iframe>
        </div>
    </el-dialog>
    <!-- 图片报告 -->
    <el-dialog v-model="state.imageDialogVisible" title="报告预览" width="450" destroy-on-close>
        <div class="dialog-content" style="overflow: auto;">
            <el-image style="width: 100%;" :src="state.reportImageUrl" fit="contain" />
        </div>
    </el-dialog>
    <!-- 车型识别报告 -->
    <el-dialog v-model="state.carTypeDialogVisible" class="car-type" title="报告预览" width="450" destroy-on-close>
        <div class="dialog-content" style="overflow: auto;">
            <el-descriptions :column="1" border>
                <el-descriptions-item label="品牌名称">{{ state.carTypeInfo?.amBrandName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车系名称">{{ state.carTypeInfo?.amSeriesName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车型名称">{{ state.carTypeInfo?.amVehicleName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="国产/进口">{{ state.carTypeInfo?.importFlag || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车型分类">{{ state.carTypeInfo?.vehCateTwoNames || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="上市时间">{{ state.carTypeInfo?.uploadDate || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车身颜色(漆色号)">{{ state.carTypeInfo?.vehicleColor || '--'
                }}</el-descriptions-item>

                <el-descriptions-item label="发动机">{{ state.carTypeInfo?.engineModel || '--' }}</el-descriptions-item>
                <el-descriptions-item label="排量(L)">{{ state.carTypeInfo?.displacement || '--' }}</el-descriptions-item>
                <el-descriptions-item label="机油加注量">{{ state.carTypeInfo?.engineDesc || '--' }}</el-descriptions-item>
                <el-descriptions-item label="燃油动力">{{ state.carTypeInfo?.powerType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="功率">{{ state.carTypeInfo?.power || '--' }}</el-descriptions-item>
                <el-descriptions-item label="燃油标号">{{ state.carTypeInfo?.roz || '--' }}</el-descriptions-item>
                <el-descriptions-item label="排放标准">{{ state.carTypeInfo?.effluentStandard || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="发动机气门数(个)">{{ state.carTypeInfo?.valveNum || '--' }}</el-descriptions-item>
                <el-descriptions-item label="气缸排列形式">{{ state.carTypeInfo?.arrayType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="排放标准">{{ state.carTypeInfo?.effluentStandard || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="驱动形式">{{ state.carTypeInfo?.drivenType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="变速器类型">{{ state.carTypeInfo?.gearboxType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="变速器档数(个)">{{ state.carTypeInfo?.gearNum || '--' }}</el-descriptions-item>

                <el-descriptions-item label="座位数">{{ state.carTypeInfo?.seats || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车身结构">{{ state.carTypeInfo?.bodyType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="进气形式">{{ state.carTypeInfo?.airIntakeType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="前轮距(mm)">{{ state.carTypeInfo?.trackFront || '--' }}</el-descriptions-item>
                <el-descriptions-item label="后轮距(mm)">{{ state.carTypeInfo?.trackRear || '--' }}</el-descriptions-item>
                <el-descriptions-item label="轴距(mm)">{{ state.carTypeInfo?.wheelBase || '--' }}</el-descriptions-item>
                <el-descriptions-item label="前轮胎规格">{{ state.carTypeInfo?.frontTyreSize || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="后轮胎规格">{{ state.carTypeInfo?.rearTyreSize || '--' }}</el-descriptions-item>
                <el-descriptions-item label="外形尺寸/长*宽*高(mm)">{{ state.carTypeInfo?.vehicleSize || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="(kg)">{{ state.carTypeInfo?.fullWeight || '--' }}</el-descriptions-item>
            </el-descriptions>
        </div>
    </el-dialog>
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { ElMessage } from 'element-plus'
import { useStore } from "vuex";
import { formatCurrency } from "@/util/formValidator";
import { getManualRefundListFun, auditingFun } from "@/api/refund"
import { getAccidentFun } from "@/api/consumption"

const store = useStore();
const search = reactive({
    userId: "",
    userPhone: "",
    orderNumber: "",
    refundStatus: "",
    refundReason: "",
    daterange: '',
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    options: [
        { label: "待处理", value: '待处理' },
        { label: "处理中", value: '处理中' },
        { label: "已退款", value: '已退款' },
        { label: "已拒绝", value: '已拒绝' },
    ],
    dialogVisible1: false,
    imageDialogVisible: false,
    reason: "",
    auditingRow: null,
    reportUrl: '',
    reportImageUrl: '',
    carTypeDialogVisible: false,
    carTypeInfo: {},
})
const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});
// 查询 1查询 2重置
const searchFun = (type) => {
    if (type == 2) {
        search.userId = '';
        search.userPhone = '';
        search.orderNumber = '';
        search.refundStatus = '';
        search.refundReason = '';
        search.daterange = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }
    for (let key in search) {
        if (search[key]) {
            if (key == 'daterange') {
                params.formValue['startTime'] = search[key][0];
                params.formValue['endTime'] = search[key][1];
                params.keys.push('startTime');
                params.keys.push('endTime');
            } else {
                params.keys.push(key);
                params.formValue[key] = search[key];
            }
        }
    }
    getManualRefundListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.tableLoading = false;
    });
}
// 退款审核按钮
const auditing = (row) => {
    state.auditingRow = row;
    state.reason = "";
    state.dialogVisible1 = true;
}
// 审核弹窗点击事件 type：1拒绝 2同意
const handleDialogClick = (type) => {
    if (type == 1) {
        if (!state.reason) {
            ElMessage.warning("请输入拒绝退款原因！");
            return;
        }
    }
    state.fullLoading = true;
    const params = {
        refundApproval: type == 1 ? false : true,
        refusalReason: type == 1 ? state.reason : '',
        orderId: state.auditingRow.orderNumber
    }
    auditingFun(params).then((res) => {
        state.dialogVisible1 = false;
        intTableData();
    }).finally(() => {
        state.fullLoading = false;
    })

}
// 单元格点击事件
const handleCellClick = (row, column, event, cell) => {
    if (column.property == 'vin') {
        // 点击车架号
        if (row.reportUrl) {
            if (row?.thirdPartyName == 'CXM') {
                if (row?.reportImageUrl) {
                    state.reportImageUrl = row.reportImageUrl;
                    state.imageDialogVisible = true;
                } else {
                    // 车信盟需要重新获取连接报告
                    state.fullLoading = true;
                    const params = {
                        id: row.reportId,
                        thirdPartyName: row.thirdPartyName
                    }
                    getAccidentFun(params).then((res) => {
                        if (res?.data?.orderInfo?.reportUrl) {
                            state.reportUrl = decodeURIComponent(res.data.orderInfo.reportUrl);
                            state.dialogVisible = true;
                        }
                    }).finally(() => {
                        state.fullLoading = false;
                    })
                }
            } else if (row?.reportUrl.includes('amBrandName')) {
                // 车型识别
                const reportInfo = JSON.parse(row.reportUrl);
                state.carTypeInfo = reportInfo[0];
                state.carTypeDialogVisible = true;
            } else {
                state.reportUrl = decodeURIComponent(row.reportUrl);
                state.dialogVisible = true;
            }
        } else {
            ElMessage.warning("未查询到报告！")
        }
    }
}

onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
.demo-ruleForm {
    margin-top: 15px;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 15px;
    float: right;
}


.dialog-content {
    height: 65vh;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}
</style>